import styled from 'styled-components/macro';
import { Button } from '../../../components/Buttons';
import { distances, colors } from '../../../styles/constants';

export const DiscountTypeButton = styled(Button as any)<{ isSelected: boolean }>`
    min-height: 60px;
    min-width: 167px;
    margin: ${distances.small} 0;
    background-color: ${(props) => (props.isSelected ? colors.primary : colors.background)};
    color: ${(props) => (props.isSelected ? colors.background : colors.primary)};
    border-color: ${(props) => (props.isSelected ? colors.primary : colors.borderDark)};
    margin-right: ${distances.small};

    &:hover {
        background-color: ${colors.primaryHover};
        border-color: ${colors.primaryHover};
    }

    @media (max-width: 768px) {
        width: 100%;
        margin-top: ${distances.small};
        margin-right: 0;
    }
`;
